<template>
  <div class="app-container">
    <ActivateLowLevelStepBar
      :desc="$t('step_3_title')"
      health="75"
    />

    <div class="mt104">
      <Block class="step2-block">
        <template v-slot:header>
          {{ $t('upload_f_step_1') }}
          <br>
          {{ $t('upload_f_step_2') }}
        </template>
        <div class="upload-card auto0">
          <img src="@/assets/images/face-img.png" alt="placeholder">
        </div>
      </Block>

      <md-button class="selfie-btn" type="primary" :inactive="!isAgree">
        {{ $t('start_selfie') }}

        <!-- 需要用一个参数来判断是不是在app中 -->
        <md-image-reader
          v-show="isAgree"
          ref="image"
          is-camera-only
          @complete="onReaderComplete"
          @error="onReaderError"
        />
      </md-button>

      <md-agree
        v-model="isAgree"
        icon-type="square"
      >
        <i18n path="flash_agreement_check" tag="div">
          <a href="javascript:void(0)" @click="$router.push({ name: 'Vida' })">
            {{ $t('link_text') }}
          </a>
        </i18n>
      </md-agree>

      <PayLoading :context="$t('waitingText')" :is-show="isShowLoading" />

      <md-dialog
        v-model="showAuditFailedDialog"
        :closable="false"
        :title="$t('d_title_auth_failed')"
        :btns="btns"
      >
        {{ $t('auth_failed_content') }}
      </md-dialog>
    </div>
  </div>
</template>

<script>
import ActivateLowLevelStepBar from '@/components/ActivateLowLevelStepBar'
import Block from '@/components/Block'
import { Button, ImageReader, Toast, Agree, Dialog } from 'mand-mobile'
import axios from 'axios'
import PayLoading from '@/components/PayLoading'
import { compression } from '@/utils/compression'
import {
  apiUpload,
  low
} from '@/api/activateLowLevelStep'
import { getCertificateLevel } from '@/store/modules/common/types'
import { TEMP_PASSWORD_CODE } from '@/constants'

export default {
  name: 'ActivateLowLevelStep3',

  components: {
    ActivateLowLevelStepBar,
    Block,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [ImageReader.name]: ImageReader,
    [Agree.name]: Agree,
    PayLoading
  },

  data () {
    return {
      isShowLoading: false,
      showAuditFailedDialog: false,
      btns: [
        {
          text: this.$t('tryAgain'),
          handler: () => {
            this.showAuditFailedDialog = false
            this.$router.replace({ name: 'ActivateLowLevelStep1' })
          }
        },
        {
          text: this.$t('manual_review'),
          handler: this.handleGoManualReview
        }
      ],
      isAgree: false // 是否勾选了用户协议
    }
  },

  methods: {
    onReaderError (name, { msg }) {
      Toast.failed(msg)
    },
    async handleGoManualReview () {
      this.showAuditFailedDialog = false
      await this.$store.dispatch(getCertificateLevel)
      this.$router.replace({
        name: 'ActivateLowLevelStep4',
        query: {
          applyAuditFlag: TEMP_PASSWORD_CODE.temp
        }
      })
    },
    // 上传活体照片
    async onReaderComplete (name, file) {
      try {
        this.isShowLoading = true
        const result = await compression(file.file)
        const { uploadUrl, contentType, objectKey } = await apiUpload({
          // 上传照片存放到服务器
          fileName: file.file.name,
          folder: 'face_id'
        })
        await axios({
          method: 'PUT',
          url: uploadUrl,
          headers: {
            'Content-Type': contentType
          },
          data: result
        })

        await low({ faceImgKey: objectKey }, { showMessage: false })

        this.$router.push({ name: 'ActivateLowLevelStep4' })
      } catch (error) {
        // 全局提示已关闭：500421 使用人审弹窗，其他业务异常展示后端返回的具体原因。
        if (+error.code === 500421) {
          this.showAuditFailedDialog = true
        } else if (error.message) {
          // 使用项目已适配的方形 Toast，避免较长的后端错误文案被单行截断。
          Toast.failed(error.message, 4000, null, document.body, true)
        }
      } finally {
        this.isShowLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.step2-block {
  ::v-deep .flash-block_header {
    padding: 48px 36px 60px;
    line-height: 48px;
  }

  ::v-deep .flash-block_body {
    padding-bottom: 60px;
  }

  .upload-card {
    width: 440px;

    img {
      width: 440px;
      height: 440px;
    }
  }
}

.selfie-btn {
  margin-top: 100px;
  margin-bottom: 20px;

  ::v-deep .md-button-content {
    font-size: 32px;
  }
}
</style>
